import useOrderRepository from "../../../../../../repository/emergency/useOrderRepository";
import {useEffect, useRef, useState} from "react";
import isNull from "../../../../../../mixin/isNull";
import {Autocomplete, Paper, TextField} from "@mui/material";
import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import CreateCustom from "./CreateCustom";
import usePaginationRepository from "../../../../../../repository/data-repository/usePaginationRepository";
import useHelper from "../../../../../../use/useHelper";
import parameter from "../../../../../../enum/parameter";
import {ArrowUpward} from "@mui/icons-material";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";

const filterOptions = (options, {inputValue}) => {
    if (inputValue.length === 0) return options;

    const removeAccent = string => string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const compareString = (string1, string2) => {
        const excludeWord = [
            "le",
            "la",
            "et",
            "un",
            "en",
            "de",
            "une",
            "des",
            "les",
            "dans",
            "du",
            "a",
            "à"
        ];

        const string2Array = string2.split(" ");

        for (let i = 0; i < string2Array.length; i++) {
            if (excludeWord.includes(string2Array[i])) {
                continue;
            }

            if (!string1.includes(string2Array[i])) {
                return false;
            }
        }

        return true;
    }

    inputValue = removeAccent(inputValue);

    return options.filter(o => compareString(removeAccent(o.standardized_item_name), inputValue));
}

export default function ({orderId, onSelect, currentQuotationItems}) {
    const helper = useHelper();
    const eventDispatcher = useEventDispatcher();
    const orderRepository = useOrderRepository();
    const paginationRepository = usePaginationRepository();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();
    const [standardizedItems, setStandardizedItems] = useState([]);
    const [createCustom, setCreateCustom] = useState(null);
    const searchInput = useRef();
    const [reload, setReload] = useState(helper.uuid());
    const standardizedItemSelectorRef = useRef();

    useEffect(() => {
        orderRepository.findOneById(orderId).exec();
    }, []);

    useEffect(() => {
        if (isNull(order) || (!isNull(standardizedItems) && standardizedItems.length > 0)) return;

        fetch();
    }, [JSON.stringify(order)]);

    useEffect(() => {
        if (isNull(standardizedItems) || standardizedItems.length === 0) return;

        setTimeout(() => eventDispatcher.launcher("select-standardized-item"), parameter.POPUP_TIME * 2);
    }, [JSON.stringify(standardizedItems)]);

    const fetch = async () => {
        setStandardizedItems((await paginationRepository.findAllStandardizedItem(order.getWorkId(), order.getPrescriberId())));
    }

    const handleCreateCustomSuccess = item => {
        onSelect(item);
        setCreateCustom(null);
    }

    if (isNull(standardizedItems) || standardizedItems.length === 0) return null;

    return (
        <>
            <Autocomplete
                key={standardizedItems.length + "-" + reload}
                freeSolo
                openOnFocus={true}
                size={"small"}
                PaperComponent={props => (
                    <Paper elevation={8} {...props} />
                )}
                options={standardizedItems.filter(si => !currentQuotationItems.map(cqi => cqi.standardized_item_id).includes(si.standardized_item_id))}
                getOptionLabel={si => si.standardized_item_name}
                getOptionKey={si => si.standardized_item_id}
                filterOptions={(options, params) => {
                    const filtered = filterOptions(options, params);

                    if (filtered.length > 0) return filtered;

                    const {inputValue} = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);

                    if (inputValue !== '' && !isExisting) {
                        filtered.push({
                            inputValue,
                            standardized_item_name: `Créer l'item "${inputValue}"`,
                            standardized_item_id: -1
                        });
                    }

                    return filtered;
                }}
                clearOnBlur={true}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Sélectionnez vos fournitures dans le catalogue"
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                "data-test": "input-standardized-item"
                            },
                        }}
                        inputRef={searchInput}
                    />
                )}
                onChange={(e, si) => {
                    if (isNull(si)) return;

                    if (si.standardized_item_id != -1) {
                        onSelect({
                            name: si.standardized_item_name,
                            description: null,
                            price: si.standardized_item_price,
                            quantity: 1,
                            standardized_item_id: si.standardized_item_id,
                            default_item_id: null
                        });
                    }

                    if (si.standardized_item_id == -1) {
                        setCreateCustom(si.inputValue);
                    }

                    setReload(helper.uuid());
                }}
                ref={standardizedItemSelectorRef}
            />
            <PopperWrapper
                elementRef={standardizedItemSelectorRef}
                placement={"bottom"}
                content={"Sélectionnez les fournitures nécessaires dans le catalogue"}
                triggeringEvent={"select-standardized-item"}
                autoCloseAfter={parameter.POPUP_TIME}
                displayCloseButton={false}
                contentColor={parameter.POPUP_COLOR}
                icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
            />

            {
                !isNull(createCustom)
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setOnClose(() => setCreateCustom(null))
                                    .setWidth("100%")
                                    .setHeight("80%")
                                    .setComponent(<CreateCustom name={createCustom} onSubmit={handleCreateCustomSuccess}/>)
                            }
                        />
                    )
                    : null
            }
        </>
    )
}